import { render, staticRenderFns } from "./ConversationTypesReport.vue?vue&type=template&id=2b689eba&scoped=true"
import script from "./ConversationTypesReport.vue?vue&type=script&lang=js"
export * from "./ConversationTypesReport.vue?vue&type=script&lang=js"
import style0 from "./ConversationTypesReport.vue?vue&type=style&index=0&id=2b689eba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b689eba",
  null
  
)

export default component.exports